import { setParentSelectedChild } from '@store/parent/parentSelectedChildIdSlice';
import { useSelector, useDispatch } from 'react-redux'
import Select from '@UI/New/Select';
import { selectProfile } from '@store/profile.reducer'
import s from './ChoiceOfChildByParent.module.css';
import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { usersAPI } from '@/api';

const PAGE_SIZE = 30;
const normalizeId = (id) =>
    id === undefined || id === null ? id : Number(id);

const ChoiceOfChildByParent = ({
    className='',
    text='',
    includeParentOption = false,
    value = undefined,
    onChange = undefined,
}) => {
    const parentSelectedChildId = useSelector((state) => state.parentSelectedChildId);
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [children, setChildren] = useState(profile?.children ?? []);
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setChildren(profile?.children ?? []);
        setVisibleCount(PAGE_SIZE);
    }, [profile?.id]);

    const loadChildren = async () => {
        if (!profile?.id || loading) return;

        setLoading(true);
        try {
            const response = await usersAPI.getChildren({ userId: profile.id });
            setChildren(response?.data?.data ?? response?.data ?? []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const childOptions = useMemo(
        () => children.map((child) => ({
            label: child.name,
            value: normalizeId(child?.id),
        })),
        [children],
    );

    const options = [
        ...(includeParentOption
            ? [{label: 'Мой профиль', value: normalizeId(profile?.id)}]
            : []),
        ...childOptions.slice(0, visibleCount),
    ];
    const selectedValue = normalizeId(
        value !== undefined ? value : parentSelectedChildId,
    );
    const handleChange = (childId) => {
        const normalizedChildId = normalizeId(childId);

        if (onChange) {
            onChange(normalizedChildId);
            return;
        }

        dispatch(setParentSelectedChild(normalizedChildId));
    };
    const filterSort = (optionA, optionB) => {
        if (includeParentOption) {
            if (Number(optionA?.value) === Number(profile?.id)) return -1;
            if (Number(optionB?.value) === Number(profile?.id)) return 1;
        }

        return (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase());
    };

    return (
        <div className={classNames(s.selectChildrenWrapper, {[className]: !!className})}>
            <Select
                className="antdSelectNewDesign"
                fields={{
                    onChange: handleChange,
                    value: selectedValue,
                    options,
                    showSearch: true,
                    allowClear: true,
                    style: {minWidth: 250},
                    placeholder: 'Выберите ученика',
                    filterOption: (input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
                    filterSort,
                    loading,
                    onDropdownVisibleChange: (open) => {
                        if (open) loadChildren();
                    },
                    onSearch: (search) => {
                        setVisibleCount(search ? childOptions.length : PAGE_SIZE);
                    },
                    onPopupScroll: (event) => {
                        const target = event.target;
                        if (
                            target.scrollTop + target.offsetHeight >= target.scrollHeight - 24 &&
                            visibleCount < childOptions.length
                        ) {
                            setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, childOptions.length));
                        }
                    },
                }}
            />
        </div>
    )
}

export default ChoiceOfChildByParent;
